/* eslint-disable jsx-a11y/label-has-associated-control */
// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames/bind";
import MediaQuery from "react-responsive";
import { connect } from "react-redux";

import {
  getProfile,
  getErrors,
  getSuccess,
  getChangePassword,
} from "../store/selectors";
import * as profileActions from "../store/actions";
import { optionsTitle } from "../../../../../../../config/types";
import { CRAFTY_CLICKS_API_KEY } from "../../../../../../../config/apiKeys";
import styles from "./styles";
import {
  Input,
  Select,
  Button,
  Description,
} from "../../../../../../../components";
import ProfileMenuResriction from "../../ProfileMenuResriction";

class MyProfile extends Component {
  state = {
    isTradeCustomer: JSON.parse(localStorage.getItem("TradeCustomer")),
  };

  onChangeInput = (value, name) => {
    this.props.changeField(value, name);
    this.props.resetErrorsAndSuccess();
  };

  onChangeInputChangePassword = (value, name) => {
    this.props.changeFieldChangePassword(value, name);
    this.props.resetErrorsAndSuccess();
  };

  changePassword = () => {
    const { changePassword, changeErrors, changePasswordRequest } = this.props;

    if (changePassword.NewPassword !== changePassword.ConfirmPassword) {
      return changeErrors(
        "password",
        "The new password does not match the confirmed one."
      );
    }

    if (changePassword.NewPassword.length < 8) {
      return changeErrors(
        "password",
        "Please enter a password that is 8 or more characters"
      );
    }

    if (changePassword.NewPassword.length > 50) {
      return changeErrors("password", "Password must not exceed 50 characters");
    }

    if (!/[A-Z]/.test(changePassword.NewPassword)) {
      return changeErrors(
        "password",
        "Please enter a password that contain an upper case character"
      );
    }

    if (!/[a-z]/.test(changePassword.NewPassword)) {
      return changeErrors(
        "password",
        "Please enter a password that contains lower case characters"
      );
    }

    if (!/[!£$%'()*,\-.:;<=>?@[\]{}^_`|~]/.test(changePassword.NewPassword)) {
      return changeErrors(
        "password",
        "Please enter a password that contains special characters"
      );
    }

    return changePasswordRequest(changePassword);
  };

  onSubmit = () => {
    if (this.props.changePassword.NewPassword) {
      this.changePassword();
    }
    const id = localStorage.getItem("loggedID");
    const token = localStorage.getItem("token");
    this.props.verifyPhoneNumber(
      {
        key: CRAFTY_CLICKS_API_KEY,
        country: "gbr",
        phone_number: this.props.profile.Mobile,
        get_network: true,
      },
      {
        profile: this.props.profile,
        id,
        token,
        pageInfo: { page: "profile" },
      }
    );
  };

  componentDidMount() {
    const { isTradeCustomer } = this.state;
    if (!isTradeCustomer) {
      const { requestProfile } = this.props;
      const id = localStorage.getItem("loggedID");
      const token = localStorage.getItem("token");
      requestProfile(id, token);
    }
  }

  componentWillUnmount() {
    this.props.resetErrorsAndSuccess();
    this.props.resetPasswordChanges();
  }

  render() {
    const { classes } = this.props;
    const { isTradeCustomer } = this.state;

    return isTradeCustomer ? (
      <ProfileMenuResriction />
    ) : (
      <div className={classes.root}>
        <form>
          <MediaQuery maxWidth={549}>
            <Description text={"My profile"} />
          </MediaQuery>
          <div className={classes.rowContainer}>
            <Select
              fixedWidth
              options={optionsTitle}
              name={"Title"}
              label={"Title"}
              value={this.props.profile.Title}
              onChange={this.onChangeInput}
            />
            <Input
              label={"First Name:"}
              fixedWidth
              required
              name={"ForeName"}
              value={this.props.profile.ForeName}
              onChange={this.onChangeInput}
            />
          </div>
          <div className={classes.rowContainer}>
            <Input
              label={"Last Name:"}
              fixedWidth
              required
              name={"SurName"}
              value={this.props.profile.SurName}
              onChange={this.onChangeInput}
            />
            <Input
              label={"Email"}
              fixedWidth
              required
              name={"EmailID"}
              value={this.props.profile.EmailID}
              onChange={this.onChangeInput}
            />
          </div>
          <div className={classes.rowContainer}>
            <Input
              label={"Mobile Number"}
              fixedWidth
              required
              name={"Mobile"}
              value={this.props.profile.Mobile}
              onChange={this.onChangeInput}
            />
          </div>
          <div className={classes.checkboxContainer}>
            <div className={classes.checkboxSubContainer}>
              <input
                type={"checkbox"}
                className={`form-check-input ${classes.checkbox}`}
                value={this.props.profile.NewsLetter}
                checked={this.props.profile.NewsLetter}
                onChange={() =>
                  this.onChangeInput(
                    !this.props.profile.NewsLetter,
                    "NewsLetter"
                  )
                }
              />
              <label className={classes.checkboxLabel}>
                Subscribe to newsletter
              </label>
            </div>
          </div>
          <div className={classes.changePasswordContainer}>
            <div className={classes.changePasswordLines} />
            <span className={classes.changePasswordText}>CHANGE PASSWORD</span>
            <div className={classes.changePasswordLines} />
          </div>
          <div className={classNames(classes.rowContainer, classes.marginTop)}>
            <Input
              fixedWidth
              label={"Current password"}
              type={"password"}
              inputType={"password"}
              name={"Password"}
              value={this.props.changePassword.Password}
              onChange={this.onChangeInputChangePassword}
            />
            <Input
              fixedWidth
              label={"New Password:"}
              type={"password"}
              inputType={"password"}
              name={"NewPassword"}
              value={this.props.changePassword.NewPassword}
              onChange={this.onChangeInputChangePassword}
            />
          </div>
          <div className={classes.rowContainer}>
            <span className={classes.passwordHelper}>
              (Your password must be at least 8 characters long and must include
              at least one number and special character.)
            </span>
            <Input
              fixedWidth
              label={"Confirm New Password:"}
              type={"password"}
              name={"ConfirmPassword"}
              inputType={"password"}
              value={this.props.changePassword.ConfirmPassword}
              onChange={this.onChangeInputChangePassword}
            />
          </div>
          {this.props.errors.password && (
            <h6 className={classes.errorText}>{this.props.errors.password}</h6>
          )}
          <h6
            className={classNames(
              classes.successText,
              !this.props.success.status ? classes.rejectedColor : ""
            )}
          >
            {this.props.success.profile}
          </h6>
          <Button
            text={"update"}
            onPress={this.onSubmit}
            style={classes.buttonStyle}
          />
        </form>
      </div>
    );
  }
}

MyProfile.propTypes = {
  classes: PropTypes.object,
  profile: PropTypes.object,
  requestProfile: PropTypes.func,
  changeField: PropTypes.func,
  changeErrors: PropTypes.func,
  changePasswordRequest: PropTypes.func,
  resetErrorsAndSuccess: PropTypes.func,
  errors: PropTypes.object,
  success: PropTypes.object,
  changePassword: PropTypes.object,
  changeFieldChangePassword: PropTypes.func,
  resetPasswordChanges: PropTypes.func,
  verifyPhoneNumber: PropTypes.func,
};

MyProfile.defaultProps = {
  classes: {},
  profile: {},
  requestProfile: () => {},
  changeField: () => {},
  changeErrors: () => {},
  changePasswordRequest: () => {},
  resetErrorsAndSuccess: () => {},
  changeFieldChangePassword: () => {},
  resetPasswordChanges: () => {},
  changePassword: {},
  errors: {},
  success: {},
  verifyPhoneNumber: () => {},
};

const mapStateToProps = (state) => {
  return {
    profile: getProfile(state),
    errors: getErrors(state),
    success: getSuccess(state),
    changePassword: getChangePassword(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    requestProfile: (id, token) =>
      dispatch(profileActions.requestProfile(id, token)),
    changePasswordRequest: (data) =>
      dispatch(profileActions.changePasswordRequest(data)),
    changeField: (value, name) =>
      dispatch(profileActions.changeField(value, name)),
    changeErrors: (value, name) =>
      dispatch(profileActions.changeErrors(value, name)),
    resetErrorsAndSuccess: () =>
      dispatch(profileActions.resetErrorsAndSuccess()),
    changeFieldChangePassword: (value, name) =>
      dispatch(profileActions.changeFieldChangePassword(value, name)),
    resetPasswordChanges: () => dispatch(profileActions.resetPasswordChanges()),
    verifyPhoneNumber: (data, dataForNextRequest) =>
      dispatch(profileActions.verifyPhoneNumber(data, dataForNextRequest)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(MyProfile));
